import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Avvvatars from 'avvvatars-react';
import { Image } from "../../../AbstractElements";
import { useAuth } from "../../../_helper/Auth/AuthProvider";
import { getUserAvatar } from "../../../_helper/Images/ImageHelper";

const UserHeader = () => {
  const history = useNavigate();
  const [avatarError, setAvatarError] = useState(false);
  const { userData } = useAuth();

  // Reset avatar error when userData changes
  useEffect(() => {
    if (userData) {
      setAvatarError(false);
    }
  }, [userData]);

  const UserMenuRedirect = (redirect) => {
    history(redirect);
  };

  // Handle avatar display based on its source
  const renderAvatar = () => {
    // If no avatar or user data, use Avvvatars
    if (!userData || !userData.avatar || avatarError) {
      return (
        <Avvvatars
          value={userData?.email || 'user@example.com'}
          size={40}
          borderColor="#3B99F7"
          variant="character"
        />
      );
    }

    // Get avatar info using our helper
    const { url } = getUserAvatar(userData.avatar, userData.google_id);
    
    // If URL is null or empty, fallback to Avvvatars
    if (!url) {
      return (
        <Avvvatars
          value={userData?.email || 'user@example.com'}
          variant="character"
          size={40}
          borderColor="#3B99F7"
        />
      );
    }
    
    // Render the image with the appropriate URL
    return (
      <Image
        attrImage={{
          className: "img-30 m-0 rounded-circle",
          alt: "profile-image",
          src: url,
          crossOrigin: "anonymous",
          referrerPolicy: "no-referrer",
          onError: (e) => {
            e.target.onError = null;
            setAvatarError(true);
          }
        }}
      />
    );
  };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <div className="avatar-wrapper" onClick={() => UserMenuRedirect(`${process.env.PUBLIC_URL}/app/my-profile`)} style={{ cursor: 'pointer' }}>
          {renderAvatar()}
        </div>
      </div>
    </li>
  );
};

export default UserHeader;